import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[positiveNumbersOnly]',
    standalone: false
})
export class PositiveNumbersOnlyDirective {
  @Input() minValue!: number;
  @Input() maxValue!: number;

  public constructor(private el: ElementRef) { }

  @HostListener('document:keypress', ['$event'])
  onKeyPress(event:any) {
    const oldValue = this.el.nativeElement.value;
    const newKey = event.key;

    if (newKey == '-' || newKey == '+' || newKey == 'e' || newKey == '.') {
      event.preventDefault();
    }

    const newValue = oldValue + newKey;
    const currentValue = parseInt(newValue);

    if (currentValue < this.minValue) {
      event.preventDefault();
    }
    if (currentValue > this.maxValue) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    const pattern = '^([0-9])';
    const maskSeperator = new RegExp(pattern, 'g');
    let isJustNumbers = maskSeperator.test(pastedText || "");
    if (!isJustNumbers) {
      event.preventDefault();
    }
  }
}

